import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdateProductQuantityEvent {
  private quantity = new Subject();
  private products = new Subject();
  private algoliaConversionQuery = new BehaviorSubject({});

  updateProductQuantity = this.quantity.asObservable();
  updateProductsQuantity = this.products.asObservable();
  updateQuerySearch = this.algoliaConversionQuery.asObservable();

  changeProductQuantity(product: any) {
    this.quantity.next(product);
  }

  sendQueryID(query: any) {
    this.algoliaConversionQuery.next(query);
  }

  sendOptimalRouteProducts(products: any){
    this.products.next( products );
  }
}
